module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/transcript-c14a2447c3441d51214449adb3919c28.svg";